<template>
  <div ref="wrap">
    <slot/>
  </div>
</template>

<script>
import { useRecipesStore } from "../stores/recipes";

export default {
  name: 'RecipesPagination',
  setup() {
    return {
      recipes: useRecipesStore(),
    }
  },
  mounted() {
    this.$refs.wrap.querySelectorAll('a').forEach(a => {
      const url = new URL(a.href);
      const page = url.searchParams.get("page");

      a.href = `/recipes/${ url.search }`;

      a.addEventListener('click', e => {
        e.preventDefault();

        this.recipes.page(url.search).then(() => {
          window.scrollTo(0,0);
        })

        let newTitle = document.title.replace(/[0-9]+/g, page);

        document.title = newTitle;
      })
    })
  },
}
</script>
